import React, {memo, useState} from "react";
import useStyles from "./useStyles";
import Button from "../../../../Components/baseComponents/Button/Button";
import {getNowEnd, getNowStart} from "../../../../tools";
import dayjs from "dayjs";

export const PeriodContainer = memo((props) => {
    const classes = useStyles();

    const {
        periodContainerClickHandler
    } = props

    const [activeButton, setActiveButton] = useState(null);

    const handleButtonClick = (index) => {
        setActiveButton(index);

        let period = {}

        switch (index) {
            case 0:
                period = {
                    from: getNowStart(),
                    to: new Date()
                }
                break
            case 1:
                const dayBefore = dayjs(new Date()).subtract(1, 'day').toDate()
                period = {
                    from: getNowStart(dayBefore),
                    to: getNowEnd(dayBefore)
                }
                break
            case 2:
                const theWholeDay = dayjs(new Date()).subtract(24, 'h').toDate()
                period = {
                    from: theWholeDay,
                    to: new Date()
                }
                break
            case 3:
                const theWheek = dayjs(new Date()).subtract(7, 'd').toDate()
                period = {
                    from: theWheek,
                    to: new Date()
                }
                break
            case 4:
                const theMonth = dayjs(new Date()).subtract(1, 'month').toDate()
                period = {
                    from: theMonth,
                    to: new Date()
                }
                break
            default:
                console.log('default !!!')

        }
        periodContainerClickHandler(period)
      };

  return (
    <div className={classes.periodContainer}>
      <Button
        className={`${classes.periodButton} ${
          activeButton === 0 ? "active" : ""
        }`}
        onClick={() => handleButtonClick(0)}
      >
        Сегодня
      </Button>
      <Button
        className={`${classes.periodButton} ${
          activeButton === 1 ? "active" : ""
        }`}
        onClick={() => handleButtonClick(1)}
      >
        Вчера
      </Button>
      <Button
        className={`${classes.periodButton} ${
          activeButton === 2 ? "active" : ""
        }`}
        onClick={() => handleButtonClick(2)}
      >
        Сутки
      </Button>
      <Button
        className={`${classes.periodButton} ${
          activeButton === 3 ? "active" : ""
        }`}
        onClick={() => handleButtonClick(3)}
      >
        Неделя
      </Button>
      <Button
        className={`${classes.periodButton} ${
          activeButton === 4 ? "active" : ""
        }`}
        onClick={() => handleButtonClick(4)}
      >
        Месяц
      </Button>
    </div>
  );
});